module.exports = " <div> <div class=card-page-container> <div class=\"mdl-grid fill\"> <div class=\"mdl-card mdl-cell fill mdl-shadow--2dp\"> <div class=mdl-card__title> <h2 class=mdl-card__title-text>{{'payment.label.crypto.title' | label}}</h2> </div> <div class=\"mdl-card__supporting-text fill\"> <p v-if=success>{{'payment.label.crypto.success' | label}}</p> <p v-else>{{'payment.label.crypto.cancel' | label}}</p> </div> </div> </div> </div> </div> ";


//////////////////
// WEBPACK FOOTER
// ./~/vue-html-loader!./~/vue-loader/lib/selector.js?type=template&index=0!./~/eslint-loader!./src/client/pages/CryptoPaymentResult.vue
// module id = 333
// module chunks = 0